<button class="close-btn" mat-icon-button [mat-dialog-close] aria-label="Close dialog">
  <mat-icon>close</mat-icon>
</button>
<img class="img" src="{{ data.textureLink }}" (error)="setImagePlug($event)" />
